import { render, staticRenderFns } from "./ModalAskForHelp.vue?vue&type=template&id=14a9e209&scoped=true"
import script from "./ModalAskForHelp.vue?vue&type=script&lang=js"
export * from "./ModalAskForHelp.vue?vue&type=script&lang=js"
import style0 from "./ModalAskForHelp.vue?vue&type=style&index=0&id=14a9e209&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a9e209",
  null
  
)

export default component.exports